import { ColumnDef } from '@tanstack/react-table'
import { ReferralModel } from '../../../entities/referral/model/types'
import { ItemLayout, TradersIcon, StatusLabel } from '@/shared/components'
import CheckIcon from '@/shared/assets/icons/conversion/checkIcon.svg?react'
import { formatCurrency } from '@/shared/lib/currency'
import { formatPercentage } from '@/shared/lib'
import { Currencies } from '@/entities/curency'
import { getReferralStatusInfo } from '@/entities/referral'

export const referralColumns: ColumnDef<ReferralModel>[] = [
  {
    accessorKey: 'username',
    header: 'Трейдер',
    cell: ({ row }) => {
      const id = row.original.id
      const status = row.original.status
      return (
        <ItemLayout
          icon={<TradersIcon status={status} />}
          title={row.getValue('username')}
          subtitle={id}
        />
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.status
      const { title, color } = getReferralStatusInfo(status)
      return <StatusLabel status={color}>{title}</StatusLabel>
    },
  },
  {
    accessorKey: 'dailyLimit',
    header: 'Суточный лимит',
    cell: ({ row }) => {
      const dailyLimit = row.original.dailyLimit
      const maxDailyLimit = row.original.totalRequisitMaxDailyLimit
      return (
        <span>
          {formatCurrency(Number(dailyLimit), Currencies.RUB)} 
          <span className="text-text-secondary">{' / ' + formatCurrency(Number(maxDailyLimit), Currencies.RUB)}</span>
        </span>
      )
    },
  },
  {
    accessorKey: 'totalTurnover',
    header: 'Общий оборот',
    cell: ({ row }) => {
      const { amountTo, amountFrom } = row.original.totalTurnover
      return (
        <span>
          {formatCurrency(amountTo, Currencies.USDT)} ≈ {formatCurrency(amountFrom, Currencies.RUB)}
        </span>
      )
    },
  },
  {
    accessorKey: 'personalProfit',
    header: 'Личная прибыль',
    cell: ({ row }) => {
      const profit = row.original.personalProfit
      return <span>{formatCurrency(Number(profit), Currencies.USDT)}</span>
    },
  },
  {
    accessorKey: 'conversion',
    header: 'Конверсия',
    cell: ({ row }) => {
      const { percentage, current, goal } = row.original.conversion
      return (
        <span className="flex items-center gap-x-1">
          <CheckIcon />
          <span className="font-klein font-medium">{percentage}%</span>
          <span className="text-text-secondary">
            {current}/{goal}
          </span>
        </span>
      )
    },
  },
  {
    accessorKey: 'refPercentage',
    header: 'Реф. процент',
    cell: ({ row }) => {
      return <span>{formatPercentage(row.original.refPercentage)}</span>
    },
  },
]
